export default __webpack_public_path__ + "static/media/support-icon.ee9ebd9c.svg";